export default "__VITE_ASSET__DATcb2IF__"